module.exports = __webpack_public_path__ + "static/media/collage-casino-images-with-roulette-woman-with-chips-hands-212girl.ca79d132.png";